import React from 'react';

const MicroJobs = () => {
    return (
        <div>
            <p>This is MicroJobs</p>
        </div>
    );
};

export default MicroJobs;